import { IsNotEmpty, IsString, MaxLength, MinLength } from 'class-validator';

export class TenantVerifyDTO {

    @IsNotEmpty()
    @IsString()
    @MinLength(20)
    @MaxLength(20)
    code: string;

}
